"use strict";

module.exports = ["New York", "Washington DC", "Boston", "San Francisco", "Los Angeles"];